
// import {
//   Autocomplete, Button, FormControlLabel,
//   Grid, Radio, RadioGroup, TextField, Typography,
//   CircularProgress, Box, Paper,
// } from "@mui/material";
// import axios from "axios";
// import React, { Fragment, memo, useEffect, useState } from "react";
// import { useDispatch } from "react-redux";
// import { setSnackbar } from "../../../../../components/hooks/snackBar/reducers";
// import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
// import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
// import { useStyle } from "../style";
// import dayjs from "dayjs";
// import _ from "lodash";
// import CustomTable from "../customTable";
// import moment from "moment";
// import { Helmet } from "react-helmet-async";

// const NetProfitSalesReport = () => {
//   const classes = useStyle();
//   const dispatch = useDispatch();

//   const pageOption = [10, 25, 50, 100];
//   const [page, setPage] = useState(0);
//   const [rowsPerPage, setRowsPerPage] = useState(100);
//   const [pageCount, setPageCount] = useState(0);
//   const [data, setData] = useState([]);
//   const [supplier, setSupplier] = useState([]);
//   const [vendor, setVendor] = useState([]);
//   const [catData, setCatData] = useState([]);
//   const [subData, setSubData] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [csvLoading, setCsvLoading] = useState(false);

//   const [dateLimit, setDateLimit] = useState({
//     fromDate: moment().subtract(1, "months").format(),
//     toDate: moment().format(),
//   });
  
//   const [totalAmount, setTotalAmount] = useState(0);
//   const [totalFlag, setTotalFlag] = useState(false);

//   const [options, setOptions] = useState({
//     customer: null,
//     category: null,
//     subCategory: null,
//     vendor: null,
//   });

//   const [reportType, setReportType] = useState("category");

//   const toNum = (v) => (isNaN(Number(v)) ? 0 : Number(v));

//   function handleOptions(value, name) {
//     setPage(0);
//     setOptions((prev) => ({ ...prev, [name]: value }));
//   }

//   // ─── COLUMNS ────────────────────────────────────────────────────────────
//   const columns = [
//     {
//       field: "sno",
//       headerName: "S.no",
//       minWidth: 70,
//       maxWidth: 100,
//       headerAlign: "center",
//       align: "center",
//       sortable: false,
//     },
//     ...(reportType === "item"
//       ? [{
//           field: "item_name",
//           headerName: "Item Name",
//           flex: 1,
//           minWidth: 160,
//           headerAlign: "center",
//           align: "center",
//           sortable: false,
//         }]
//       : []),
//     {
//       field: "outlet_name",
//       headerName: "Outlet Name",
//       flex: 1,
//       minWidth: 140,
//       headerAlign: "center",
//       align: "center",
//       sortable: false,
//     },
//     {
//       field: "supplier_name",
//       headerName: "Supplier Name",
//       flex: 1,
//       minWidth: 140,
//       headerAlign: "center",
//       align: "center",
//       sortable: false,
//     },
//     {
//       field: "category_name",
//       headerName: "Category Name",
//       flex: 1,
//       minWidth: 140,
//       headerAlign: "center",
//       align: "center",
//       sortable: false,
//     },
//     {
//       field: "subcategory_name",
//       headerName: "Subcategory Name",
//       flex: 1,
//       minWidth: 150,
//       headerAlign: "center",
//       align: "right",
//       sortable: false,
//     },
//     {
//   field: "total_qty",
//   headerName: "Qty",
//   flex: 1,
//   minWidth: 100,
//   headerAlign: "center",
//   align: "right",
//   sortable: false,
// },
//     {
//       field: "total_mrp",
//       headerName: "MRP Value",
//       flex: 1,
//       minWidth: 120,
//       headerAlign: "center",
//       align: "right",
//       sortable: false,
//     },
//     {
//   field: "total_discount_amount",
//   headerName: "Discount Amount",
//   flex: 1,
//   minWidth: 140,
//   headerAlign: "center",
//   align: "right",
//   sortable: false,
// },
// {
//   field: "discounted_mrp",
//   headerName: "MRP - Discount",
//   flex: 1,
//   minWidth: 140,
//   headerAlign: "center",
//   align: "right",
//   sortable: false,
// },
//     {
//       field: "purchase_value_percent",
//       headerName: "Purchase Value %",
//       flex: 1,
//       minWidth: 150,
//       headerAlign: "center",
//       align: "right",
//       sortable: false,
//     },
//     {
//       field: "gross_profit_percent",
//       headerName: "Gross Profit %",
//       flex: 1,
//       minWidth: 130,
//       headerAlign: "center",
//       align: "right",
//       sortable: false,
//       renderCell: (params) => <strong>{params.value}</strong>,
//     },
//     {
//   field: "discounted_gross_profit_percent",
//   headerName: "Discounted GP %",
//   flex: 1,
//   minWidth: 160,
//   headerAlign: "center",
//   align: "right",
//   sortable: false,
// },
//   ];

//   // ─── ROWS ────────────────────────────────────────────────────────────────
//   // ✅ FIXED: Use idx+1 as id always — prevents duplicate/wrong ids when
//   //    val.outlet_id is the same across multiple rows (e.g. all rows for
//   //    outlet 10 were getting id=10, causing DataGrid to skip/merge rows)
//   const rows = _.map(data, (val, idx) => ({
//     id: idx + 1,
//     sno: page * rowsPerPage + idx + 1,
//     item_name:              val.item_name        || "",
//     outlet_name:            val.outlet_name      || "",
//     supplier_name:          val.supplier_name    || "",
//     category_name:          val.category_name    || "",
//     subcategory_name:       val.subcategory_name || "",
//     total_qty: toNum(val.total_qty).toFixed(2),
//     total_mrp:              toNum(val.total_mrp).toFixed(2),
//     total_discount_amount: toNum(val.total_discount_amount).toFixed(2),
//     discounted_mrp: toNum(val.discounted_mrp).toFixed(2),
//     purchase_value_percent: toNum(val.purchase_value_percent).toFixed(2),
//     gross_profit_percent:   toNum(val.gross_profit_percent).toFixed(2),
//     discounted_gross_profit_percent:toNum(val.discounted_gross_profit_percent).toFixed(2),
//   }));

//   const props = {
//     columns,
//     rows,
//     page,
//     setPage,
//     rowsPerPage,
//     setRowsPerPage,
//     // ✅ CustomTable does: Math.ceil(pageCount / rowsPerPage)
//     // So pageCount must be total RECORDS (e.g. 500), same as OutletSalesReport
//     pageCount,
//     pageOption,
//     totalAmount,   // avg gross profit % — shown in footer
//     totalFlag,
//     setSearch: () => {},
//   };

//   // ─── FOOTER: avg gross profit % ─────────────────────────────────────────
//   useEffect(() => {
//     setTotalFlag(true);
//     if (!data.length) {
//       setTotalAmount(0);
//       return;
//     }
//     const sum = data.reduce((acc, val) => acc + toNum(val.gross_profit_percent), 0);
//     setTotalAmount((sum / data.length).toFixed(2));
//   }, [data]);

//   function handleChange(e, name) {
//     setDateLimit((prev) => ({ ...prev, [name]: dayjs(e).format() }));
//   }

//   // ─── MASTER DATA ─────────────────────────────────────────────────────────
//   function getSupplierData() {
//     axios.get("/v1/outlet/list/1")
//       .then((res) => setSupplier([{ id: 0, fullname: "All" }, ...res.data]))
//       .catch((err) => dispatch(setSnackbar(true, "error", err.response?.data?.error)));
//   }

//   function getVendorData() {
//     axios.get("/v1/supplier")
//       .then((res) => setVendor(res.data))
//       .catch((err) => dispatch(setSnackbar(true, "error", err.response?.data?.error)));
//   }

//   function getCategory() {
//     axios.get("/v1/categories")
//       .then((res) => setCatData(res.data.filter((val) => val.is_active)))
//       .catch((err) => dispatch(setSnackbar(true, "error", err.response?.data?.error)));
//   }

//   function getSubCategory() {
//     axios.get("/v1/subcategories")
//       .then((res) => setSubData(res.data))
//       .catch((err) => dispatch(setSnackbar(true, "error", err.response?.data?.error)));
//   }

//   // ─── MAIN FETCH ──────────────────────────────────────────────────────────
//   function handleSalesReturn() {
//     // ✅ Don't fetch if no outlet selected
//     if (!options.customer) return;

//     setLoading(true);

//     const postData = {
//       from_date:   moment(dateLimit.fromDate).format("YYYY-MM-DD"),
//       to_date:     moment(dateLimit.toDate).format("YYYY-MM-DD"),
//       vendor_id:   options.vendor?.id      || 0,
//       outlet_id:   options.customer?.id    ?? 0,
//       main_cat_id: options.category?.id    || 0,
//       sub_cat_id:  options.subCategory?.id || 0,
//     };

//     // ✅ page_size & current_page in URL params — same as OutletSalesReport
//     const url = reportType === "item"
//       ? `/v1/reports/sales/profit/itemwise/${rowsPerPage}/${page + 1}`
//       : `/v1/reports/sales/profit/${rowsPerPage}/${page + 1}`;

//     axios.post(url, postData)
//       .then((res) => {
//         setData(res.data?.data || []);
//         // ✅ Same as OutletSalesReport: setPageCount(res.data.meta.pagination.total)
//         setPageCount(res.data?.meta?.pagination?.total || 0);
//       })
//       .catch((err) => {
//         setData([]);
//         setPageCount(0);
//         dispatch(setSnackbar(
//           true, "error",
//           err.response?.data?.errors?.[0]?.message || "Something went wrong"
//         ));
//       })
//       .finally(() => setLoading(false));
//   }

//   // ─── RESET ───────────────────────────────────────────────────────────────
//   function handleReset() {
//     setOptions({ customer: null, category: null, subCategory: null, vendor: null });
//     setDateLimit({
//       fromDate: moment().subtract(1, "months").format(),
//       toDate: moment().format(),
//     });
//     setReportType("category");
//     setPage(0);
//     setData([]);
//     setPageCount(0);
//     setTotalAmount(0);
//   }

//   // ─── CSV ─────────────────────────────────────────────────────────────────
//   const handleDownloadCSV = async () => {
//     if (!options.customer) {
//       dispatch(setSnackbar(true, "error", "Please select an outlet"));
//       return;
//     }
//     if (csvLoading) return;
//     setCsvLoading(true);

//     const postData = {
//       from_date:   moment(dateLimit.fromDate).format("YYYY-MM-DD"),
//       to_date:     moment(dateLimit.toDate).format("YYYY-MM-DD"),
//       vendor_id:   options.vendor?.id      || 0,
//       outlet_id:   options.customer?.id    ?? 0,
//       main_cat_id: options.category?.id    || 0,
//       sub_cat_id:  options.subCategory?.id || 0,
//     };

//     // ✅ 99999/1 to get all records for CSV
//     const url = reportType === "item"
//       ? `/v1/reports/sales/profit/itemwise/99999/1`
//       : `/v1/reports/sales/profit/99999/1`;

//     try {
//       const res     = await axios.post(url, postData);
//       const allRows = res.data?.data || [];
//       const isItem  = reportType === "item";

//       const headers = isItem
//         ? ["S.no", "Item Name", "Outlet", "Supplier", "Category", "Subcategory","Qty","MRP Value","Discount Amount","MRP - Discount","Purchase Value %", "Gross Profit %","Discounted GP %"]
//         : ["S.no", "Outlet", "Supplier", "Category", "Subcategory","Qty","MRP Value","Discount Amount","MRP - Discount","Purchase Value %", "Gross Profit %","Discounted GP %"];

//       const dataRows = allRows.map((val, idx) =>
//         isItem
//           ? [idx + 1, val.item_name || "", val.outlet_name || "", val.supplier_name || "",
//              val.category_name || "", val.subcategory_name || "",
//              toNum(val.total_qty).toFixed(2),
//              toNum(val.total_mrp).toFixed(2),
//              toNum(val.total_discount_amount).toFixed(2),
//              toNum(val.discounted_mrp).toFixed(2),
//              toNum(val.purchase_value_percent).toFixed(2),
//              toNum(val.gross_profit_percent).toFixed(2)]
//           : [idx + 1, val.outlet_name || "", val.supplier_name || "",
//              val.category_name || "", val.subcategory_name || "",
//              toNum(val.total_mrp).toFixed(2),
//              toNum(val.purchase_value_percent).toFixed(2),
//              toNum(val.gross_profit_percent).toFixed(2),
//              toNum(val.discounted_gross_profit_percent).toFixed(2),
//             ],
//       );

//       const avgProfit = allRows.length > 0
//         ? (allRows.reduce((acc, val) => acc + toNum(val.gross_profit_percent), 0) / allRows.length).toFixed(2)
//         : 0;

//       const csvData = [
//         ["Outlet Name", options.customer?.fullname || ""],
//         ["From Date",   moment(dateLimit.fromDate).format("DD-MM-YYYY")],
//         ["To Date",     moment(dateLimit.toDate).format("DD-MM-YYYY")],
//         ["Report Type", isItem ? "Item Wise" : "Category Wise"],
//         [],
//         headers,
//         ...dataRows,
//         [],
//         ["", ...(isItem ? [""] : []), "", "", "", "", "", "", `Avg Gross Profit %: ${avgProfit}`],
//       ];

//       const csvContent = csvData
//         .map((row) => row.map((item) => `"${item ?? ""}"`).join(","))
//         .join("\n");

//       const blob = new Blob([csvContent], { type: "text/csv" });
//       const url2 = window.URL.createObjectURL(blob);
//       const link = document.createElement("a");
//       link.href = url2;
//       link.setAttribute("download",
//         `${isItem ? "ItemWise" : "CategoryWise"}_Profit_Report_${moment().format("YYYY-MM-DD")}.csv`
//       );
//       document.body.appendChild(link);
//       link.click();
//       document.body.removeChild(link);
//     } catch (error) {
//       dispatch(setSnackbar(
//         true, "error",
//         error?.response?.data?.errors?.[0]?.message || "CSV Download failed"
//       ));
//     } finally {
//       setCsvLoading(false);
//     }
//   };

//   // ─── EFFECTS ─────────────────────────────────────────────────────────────
//   useEffect(() => {
//     getSupplierData();
//     getCategory();
//     getSubCategory();
//     getVendorData();
//   }, []);

//   useEffect(() => {
//     // ✅ Only fetch when outlet is selected — same guard as OutletSalesReport
//     if (options.customer && dateLimit.fromDate && dateLimit.toDate) {
//       handleSalesReturn();
//     }
//   }, [rowsPerPage, page, dateLimit, options, reportType]);

//   // ─── RENDER ──────────────────────────────────────────────────────────────
//   return (
//     <Fragment>
//       <Helmet><title>Net Profit Sales Reports</title></Helmet>
//       <Typography variant="h6">Net Profit Sales Reports</Typography>

//       <Grid container spacing={2} className="p-2 pt-2">

//         <Grid item md={3}>
//           <Autocomplete
//             size="small"
//             options={supplier}
//             value={options.customer || null}
//             onChange={(e, value) => handleOptions(value, "customer")}
//             getOptionLabel={(option) => option.fullname}
//             isOptionEqualToValue={(option, value) => option?.id === value?.id}
//             clearOnEscape
//             renderInput={(params) => <TextField {...params} label="Select Outlet *" />}
//           />
//         </Grid>

//         <Grid item md={3}>
//           <Autocomplete
//             size="small"
//             value={options.vendor}
//             options={vendor}
//             getOptionLabel={(option) => option?.name || ""}
//             isOptionEqualToValue={(o, v) => o?.id === v?.id}
//             onChange={(e, value) => handleOptions(value, "vendor")}
//             renderInput={(params) => <TextField {...params} label="Supplier" />}
//           />
//         </Grid>

//         <Grid item md={3}>
//           <Autocomplete
//             size="small"
//             value={options.category}
//             options={catData}
//             getOptionLabel={(option) => option.category_name}
//             onChange={(e, value) => handleOptions(value, "category")}
//             renderInput={(params) => <TextField {...params} label="Category" />}
//           />
//         </Grid>

//         <Grid item md={3}>
//           <Autocomplete
//             size="small"
//             options={subData}
//             value={options.subCategory}
//             getOptionLabel={(option) => option.subcategory_name}
//             onChange={(e, value) => handleOptions(value, "subCategory")}
//             renderInput={(params) => <TextField {...params} label="Sub Category" />}
//           />
//         </Grid>

//         <Grid item md={3}>
//           <LocalizationProvider dateAdapter={AdapterDayjs}>
//             <DatePicker
//               onChange={(e) => handleChange(e, "fromDate")}
//               value={dayjs(dateLimit.fromDate)}
//               format="DD-MM-YYYY"
//               slotProps={{ textField: { size: "small", label: "From", style: { width: "100%" } } }}
//             />
//           </LocalizationProvider>
//         </Grid>

//         <Grid item md={3}>
//           <LocalizationProvider dateAdapter={AdapterDayjs}>
//             <DatePicker
//               onChange={(e) => handleChange(e, "toDate")}
//               value={dayjs(dateLimit.toDate)}
//               format="DD-MM-YYYY"
//               slotProps={{ textField: { size: "small", label: "To", style: { width: "100%" } } }}
//             />
//           </LocalizationProvider>
//         </Grid>

//         <Grid item md={3}>
//           <RadioGroup
//             row
//             value={reportType}
//             onChange={(e) => { setPage(0); setReportType(e.target.value); }}
//           >
//             <FormControlLabel value="category" control={<Radio />} label="CategoryWise" />
//             <FormControlLabel value="item"     control={<Radio />} label="ItemWise" />
//           </RadioGroup>
//         </Grid>

//         <Grid item md={1.5}>
//           <Button variant="contained" color="secondary" fullWidth onClick={handleReset}>
//             Reset
//           </Button>
//         </Grid>

//         <Grid item md={1.5}>
//           <Button
//             variant="contained"
//             fullWidth
//             onClick={handleDownloadCSV}
//             disabled={csvLoading}
//           >
//             {csvLoading ? <CircularProgress size={22} color="inherit" /> : "Download"}
//           </Button>
//         </Grid>
//       </Grid>

//       <Box position="relative" width="100%">
//         <Paper elevation={2}>
//           <CustomTable props={props} />
//         </Paper>
//         {loading && (
//           <Box
//             display="flex" justifyContent="center" alignItems="center"
//             position="absolute" top={0} left={0} right={0} bottom={0}
//             bgcolor="rgba(255, 255, 255, 0.7)" zIndex={1}
//           >
//             <CircularProgress size={50} />
//           </Box>
//         )}
//       </Box>
//     </Fragment>
//   );
// };

// export default memo(NetProfitSalesReport);

// import {
//   Autocomplete, Button, FormControlLabel,
//   Grid, Radio, RadioGroup, TextField, Typography,
//   CircularProgress, Box, Paper,
// } from "@mui/material";
// import axios from "axios";
// import React, { Fragment, memo, useEffect, useState } from "react";
// import { useDispatch } from "react-redux";
// import { setSnackbar } from "../../../../../components/hooks/snackBar/reducers";
// import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
// import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
// import { useStyle } from "../style";
// import dayjs from "dayjs";
// import _ from "lodash";
// import CustomTable from "../customTable";
// import moment from "moment";
// import { Helmet } from "react-helmet-async";

// const NetProfitSalesReport = () => {
//   const classes = useStyle();
//   const dispatch = useDispatch();

//   const pageOption = [10, 25, 50, 100];
//   const [page, setPage] = useState(0);
//   const [rowsPerPage, setRowsPerPage] = useState(100);
//   const [pageCount, setPageCount] = useState(0);
//   const [data, setData] = useState([]);
//   const [supplier, setSupplier] = useState([]);
//   const [vendor, setVendor] = useState([]);
//   const [catData, setCatData] = useState([]);
//   const [subData, setSubData] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [csvLoading, setCsvLoading] = useState(false);

//   const [dateLimit, setDateLimit] = useState({
//     fromDate: moment().subtract(1, "months").format(),
//     toDate: moment().format(),
//   });

//   const [totalAmount, setTotalAmount] = useState(0);
//   const [totalFlag, setTotalFlag] = useState(false);

//   const [options, setOptions] = useState({
//     customer: null,
//     category: null,
//     subCategory: null,
//     vendor: null,
//   });

//   const [reportType, setReportType] = useState("category");

//   const toNum = (v) => (isNaN(Number(v)) ? 0 : Number(v));

//   function handleOptions(value, name) {
//     setPage(0);
//     setOptions((prev) => ({ ...prev, [name]: value }));
//   }

//   const columns = [
//     {
//       field: "sno",
//       headerName: "S.no",
//       minWidth: 70,
//       maxWidth: 100,
//       headerAlign: "center",
//       align: "center",
//       sortable: false,
//     },
//     ...(reportType === "item"
//       ? [{
//           field: "item_name",
//           headerName: "Item Name",
//           flex: 1,
//           minWidth: 160,
//           headerAlign: "center",
//           align: "center",
//           sortable: false,
//         }]
//       : []),
//     {
//       field: "outlet_name",
//       headerName: "Outlet Name",
//       flex: 1,
//       minWidth: 140,
//       headerAlign: "center",
//       align: "center",
//       sortable: false,
//     },
//     {
//       field: "supplier_name",
//       headerName: "Supplier Name",
//       flex: 1,
//       minWidth: 140,
//       headerAlign: "center",
//       align: "center",
//       sortable: false,
//     },
//     {
//       field: "category_name",
//       headerName: "Category Name",
//       flex: 1,
//       minWidth: 140,
//       headerAlign: "center",
//       align: "center",
//       sortable: false,
//     },
//     {
//       field: "subcategory_name",
//       headerName: "Subcategory Name",
//       flex: 1,
//       minWidth: 150,
//       headerAlign: "center",
//       align: "right",
//       sortable: false,
//     },
//     {
//       field: "total_qty",
//       headerName: "Qty",
//       flex: 1,
//       minWidth: 100,
//       headerAlign: "center",
//       align: "right",
//       sortable: false,
//     },
//     {
//       field: "total_mrp",
//       headerName: "MRP Value",
//       flex: 1,
//       minWidth: 120,
//       headerAlign: "center",
//       align: "right",
//       sortable: false,
//     },
//     {
//       field: "total_discount_amount",
//       headerName: "Discount Amount",
//       flex: 1,
//       minWidth: 140,
//       headerAlign: "center",
//       align: "right",
//       sortable: false,
//     },
//     {
//       field: "discounted_mrp",
//       headerName: "MRP - Discount",
//       flex: 1,
//       minWidth: 140,
//       headerAlign: "center",
//       align: "right",
//       sortable: false,
//     },
//     {
//       field: "purchase_value_percent",
//       headerName: "Purchase Value %",
//       flex: 1,
//       minWidth: 150,
//       headerAlign: "center",
//       align: "right",
//       sortable: false,
//     },
//     {
//       field: "gross_profit_percent",
//       headerName: "Gross Profit %",
//       flex: 1,
//       minWidth: 130,
//       headerAlign: "center",
//       align: "right",
//       sortable: false,
//       renderCell: (params) => <strong>{params.value}</strong>,
//     },
//     {
//       field: "discounted_gross_profit_percent",
//       headerName: "Discounted GP %",
//       flex: 1,
//       minWidth: 160,
//       headerAlign: "center",
//       align: "right",
//       sortable: false,
//     },
//   ];

//   const rows = _.map(data, (val, idx) => ({
//     id: idx + 1,
//     sno: page * rowsPerPage + idx + 1,
//     item_name:                       val.item_name        || "",
//     outlet_name:                     val.outlet_name      || "",
//     supplier_name:                   val.supplier_name    || "",
//     category_name:                   val.category_name    || "",
//     subcategory_name:                val.subcategory_name || "",
//     total_qty:                       toNum(val.total_qty).toFixed(2),
//     total_mrp:                       toNum(val.total_mrp).toFixed(2),
//     total_discount_amount:           toNum(val.total_discount_amount).toFixed(2),
//     discounted_mrp:                  toNum(val.discounted_mrp).toFixed(2),
//     purchase_value_percent:          toNum(val.purchase_value_percent).toFixed(2),
//     gross_profit_percent:            toNum(val.gross_profit_percent).toFixed(2),
//     discounted_gross_profit_percent: toNum(val.discounted_gross_profit_percent).toFixed(2),
//   }));

//   const props = {
//     columns,
//     rows,
//     page,
//     setPage,
//     rowsPerPage,
//     setRowsPerPage,
//     pageCount,
//     pageOption,
//     totalAmount,
//     totalFlag,
//     setSearch: () => {},
//   };

//   useEffect(() => {
//     setTotalFlag(true);
//     if (!data.length) {
//       setTotalAmount(0);
//       return;
//     }
//     const sum = data.reduce((acc, val) => acc + toNum(val.gross_profit_percent), 0);
//     setTotalAmount((sum / data.length).toFixed(2));
//   }, [data]);

//   function handleChange(e, name) {
//     setDateLimit((prev) => ({ ...prev, [name]: dayjs(e).format() }));
//   }

//   function getSupplierData() {
//     axios.get("/v1/outlet/list/1")
//       .then((res) => setSupplier([{ id: 0, fullname: "All" }, ...res.data]))
//       .catch((err) => dispatch(setSnackbar(true, "error", err.response?.data?.error)));
//   }

//   function getVendorData() {
//     axios.get("/v1/supplier")
//       .then((res) => setVendor(res.data))
//       .catch((err) => dispatch(setSnackbar(true, "error", err.response?.data?.error)));
//   }

//   function getCategory() {
//     axios.get("/v1/categories")
//       .then((res) => setCatData(res.data.filter((val) => val.is_active)))
//       .catch((err) => dispatch(setSnackbar(true, "error", err.response?.data?.error)));
//   }

//   function getSubCategory() {
//     axios.get("/v1/subcategories")
//       .then((res) => setSubData(res.data))
//       .catch((err) => dispatch(setSnackbar(true, "error", err.response?.data?.error)));
//   }
//   function handleSalesReturn() {
//     if (!options.customer) return;

//     setLoading(true);

//     const postData = {
//       from_date:   moment(dateLimit.fromDate).format("YYYY-MM-DD"),
//       to_date:     moment(dateLimit.toDate).format("YYYY-MM-DD"),
//       vendor_id:   options.vendor?.id      || 0,
//       outlet_id:   options.customer?.id    ?? 0,
//       main_cat_id: options.category?.id    || 0,
//       sub_cat_id:  options.subCategory?.id || 0,
//     };

//     const url = reportType === "item"
//       ? `/v1/reports/sales/profit/itemwise/${rowsPerPage}/${page + 1}`
//       : `/v1/reports/sales/profit/${rowsPerPage}/${page + 1}`;

//     axios.post(url, postData)
//       .then((res) => {
//         setData(res.data?.data || []);
//         setPageCount(res.data?.meta?.pagination?.total || 0);
//       })
//       .catch((err) => {
//         setData([]);
//         setPageCount(0);
//         dispatch(setSnackbar(
//           true, "error",
//           err.response?.data?.errors?.[0]?.message || "Something went wrong"
//         ));
//       })
//       .finally(() => setLoading(false));
//   }

//   function handleReset() {
//     setOptions({ customer: null, category: null, subCategory: null, vendor: null });
//     setDateLimit({
//       fromDate: moment().subtract(1, "months").format(),
//       toDate: moment().format(),
//     });
//     setReportType("category");
//     setPage(0);
//     setData([]);
//     setPageCount(0);
//     setTotalAmount(0);
//   }

//   const handleDownloadCSV = async () => {
//     if (!options.customer) {
//       dispatch(setSnackbar(true, "error", "Please select an outlet"));
//       return;
//     }
//     if (csvLoading) return;
//     setCsvLoading(true);

//     const postData = {
//       from_date:   moment(dateLimit.fromDate).format("YYYY-MM-DD"),
//       to_date:     moment(dateLimit.toDate).format("YYYY-MM-DD"),
//       vendor_id:   options.vendor?.id      || 0,
//       outlet_id:   options.customer?.id    ?? 0,
//       main_cat_id: options.category?.id    || 0,
//       sub_cat_id:  options.subCategory?.id || 0,
//     };

//     const url = reportType === "item"
//       ? `/v1/reports/sales/profit/itemwise/99999/1`
//       : `/v1/reports/sales/profit/99999/1`;

//     try {
//       const res     = await axios.post(url, postData);
//       const allRows = res.data?.data || [];
//       const isItem  = reportType === "item";

//       const headers = isItem
//         ? ["S.no", "Item Name", "Outlet", "Supplier", "Category", "Subcategory", "Qty", "MRP Value", "Discount Amount", "MRP - Discount", "Purchase Value %", "Gross Profit %", "Discounted GP %"]
//         : ["S.no", "Outlet", "Supplier", "Category", "Subcategory", "Qty", "MRP Value", "Discount Amount", "MRP - Discount", "Purchase Value %", "Gross Profit %", "Discounted GP %"];

//       const dataRows = allRows.map((val, idx) =>
//         isItem
//           ? [
//               idx + 1,
//               val.item_name              || "",
//               val.outlet_name            || "",
//               val.supplier_name          || "",
//               val.category_name          || "",
//               val.subcategory_name       || "",
//               toNum(val.total_qty).toFixed(2),
//               toNum(val.total_mrp).toFixed(2),
//               toNum(val.total_discount_amount).toFixed(2),
//               toNum(val.discounted_mrp).toFixed(2),
//               toNum(val.purchase_value_percent).toFixed(2),
//               toNum(val.gross_profit_percent).toFixed(2),
//               toNum(val.discounted_gross_profit_percent).toFixed(2),
//             ]
//           : [
//               idx + 1,
//               val.outlet_name            || "",
//               val.supplier_name          || "",
//               val.category_name          || "",
//               val.subcategory_name       || "",
//               toNum(val.total_qty).toFixed(2),
//               toNum(val.total_mrp).toFixed(2),
//               toNum(val.total_discount_amount).toFixed(2),
//               toNum(val.discounted_mrp).toFixed(2),
//               toNum(val.purchase_value_percent).toFixed(2),
//               toNum(val.gross_profit_percent).toFixed(2),
//               toNum(val.discounted_gross_profit_percent).toFixed(2),
//             ]
//       );

//       const avgProfit = allRows.length > 0
//         ? (allRows.reduce((acc, val) => acc + toNum(val.gross_profit_percent), 0) / allRows.length).toFixed(2)
//         : 0;

//       const footerRow = isItem
//         ? ["", "", "", "", "", "", "", "", "", "", "", "", `Avg Gross Profit %: ${avgProfit}`]
//         : ["", "", "", "", "", "", "", "", "", "", "", `Avg Gross Profit %: ${avgProfit}`];

//       const csvData = [
//         ["Outlet Name", options.customer?.fullname || ""],
//         ["From Date",   moment(dateLimit.fromDate).format("DD-MM-YYYY")],
//         ["To Date",     moment(dateLimit.toDate).format("DD-MM-YYYY")],
//         ["Report Type", isItem ? "Item Wise" : "Category Wise"],
//         [],
//         headers,
//         ...dataRows,
//         [],
//         footerRow,
//       ];

//       const csvContent = csvData
//         .map((row) => row.map((item) => `"${item ?? ""}"`).join(","))
//         .join("\n");

//       const blob = new Blob([csvContent], { type: "text/csv" });
//       const url2 = window.URL.createObjectURL(blob);
//       const link = document.createElement("a");
//       link.href = url2;
//       link.setAttribute("download",
//         `${isItem ? "ItemWise" : "CategoryWise"}_Profit_Report_${moment().format("YYYY-MM-DD")}.csv`
//       );
//       document.body.appendChild(link);
//       link.click();
//       document.body.removeChild(link);
//     } catch (error) {
//       dispatch(setSnackbar(
//         true, "error",
//         error?.response?.data?.errors?.[0]?.message || "CSV Download failed"
//       ));
//     } finally {
//       setCsvLoading(false);
//     }
//   };

//   useEffect(() => {
//     getSupplierData();
//     getCategory();
//     getSubCategory();
//     getVendorData();
//   }, []);

//   useEffect(() => {
//     if (options.customer && dateLimit.fromDate && dateLimit.toDate) {
//       handleSalesReturn();
//     }
//   }, [rowsPerPage, page, dateLimit, options, reportType]);

//   return (
//     <Fragment>
//       <Helmet><title>Net Profit Sales Reports</title></Helmet>
//       <Typography variant="h6">Net Profit Sales Reports</Typography>

//       <Grid container spacing={2} className="p-2 pt-2">

//         <Grid item md={3}>
//           <Autocomplete
//             size="small"
//             options={supplier}
//             value={options.customer || null}
//             onChange={(e, value) => handleOptions(value, "customer")}
//             getOptionLabel={(option) => option.fullname}
//             isOptionEqualToValue={(option, value) => option?.id === value?.id}
//             clearOnEscape
//             renderInput={(params) => <TextField {...params} label="Select Outlet *" />}
//           />
//         </Grid>

//         <Grid item md={3}>
//           <Autocomplete
//             size="small"
//             value={options.vendor}
//             options={vendor}
//             getOptionLabel={(option) => option?.name || ""}
//             isOptionEqualToValue={(o, v) => o?.id === v?.id}
//             onChange={(e, value) => handleOptions(value, "vendor")}
//             renderInput={(params) => <TextField {...params} label="Supplier" />}
//           />
//         </Grid>

//         <Grid item md={3}>
//           <Autocomplete
//             size="small"
//             value={options.category}
//             options={catData}
//             getOptionLabel={(option) => option.category_name}
//             onChange={(e, value) => handleOptions(value, "category")}
//             renderInput={(params) => <TextField {...params} label="Category" />}
//           />
//         </Grid>

//         <Grid item md={3}>
//           <Autocomplete
//             size="small"
//             options={subData}
//             value={options.subCategory}
//             getOptionLabel={(option) => option.subcategory_name}
//             onChange={(e, value) => handleOptions(value, "subCategory")}
//             renderInput={(params) => <TextField {...params} label="Sub Category" />}
//           />
//         </Grid>

//         <Grid item md={3}>
//           <LocalizationProvider dateAdapter={AdapterDayjs}>
//             <DatePicker
//               onChange={(e) => handleChange(e, "fromDate")}
//               value={dayjs(dateLimit.fromDate)}
//               format="DD-MM-YYYY"
//               slotProps={{ textField: { size: "small", label: "From", style: { width: "100%" } } }}
//             />
//           </LocalizationProvider>
//         </Grid>

//         <Grid item md={3}>
//           <LocalizationProvider dateAdapter={AdapterDayjs}>
//             <DatePicker
//               onChange={(e) => handleChange(e, "toDate")}
//               value={dayjs(dateLimit.toDate)}
//               format="DD-MM-YYYY"
//               slotProps={{ textField: { size: "small", label: "To", style: { width: "100%" } } }}
//             />
//           </LocalizationProvider>
//         </Grid>

//         <Grid item md={3}>
//           <RadioGroup
//             row
//             value={reportType}
//             onChange={(e) => { setPage(0); setReportType(e.target.value); }}
//           >
//             <FormControlLabel value="category" control={<Radio />} label="CategoryWise" />
//             <FormControlLabel value="item"     control={<Radio />} label="ItemWise" />
//           </RadioGroup>
//         </Grid>

//         <Grid item md={1.5}>
//           <Button variant="contained" color="secondary" fullWidth onClick={handleReset}>
//             Reset
//           </Button>
//         </Grid>

//         <Grid item md={1.5}>
//           <Button
//             variant="contained"
//             fullWidth
//             onClick={handleDownloadCSV}
//             disabled={csvLoading}
//           >
//             {csvLoading ? <CircularProgress size={22} color="inherit" /> : "Download"}
//           </Button>
//         </Grid>
//       </Grid>

//       <Box position="relative" width="100%">
//         <Paper elevation={2}>
//           <CustomTable props={props} />
//         </Paper>
//         {loading && (
//           <Box
//             display="flex" justifyContent="center" alignItems="center"
//             position="absolute" top={0} left={0} right={0} bottom={0}
//             bgcolor="rgba(255, 255, 255, 0.7)" zIndex={1}
//           >
//             <CircularProgress size={50} />
//           </Box>
//         )}
//       </Box>
//     </Fragment>
//   );
// };

// export default memo(NetProfitSalesReport);

import {
  Autocomplete, Button, FormControlLabel,
  Grid, Radio, RadioGroup, TextField, Typography,
  CircularProgress, Box, Paper,
} from "@mui/material";
import axios from "axios";
import React, { Fragment, memo, useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { setSnackbar } from "../../../../../components/hooks/snackBar/reducers";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { useStyle } from "../style";
import dayjs from "dayjs";
import _ from "lodash";
import CustomTable from "../customTable";
import moment from "moment";
import { Helmet } from "react-helmet-async";

const NetProfitSalesReport = () => {
  const classes = useStyle();
  const dispatch = useDispatch();

  const pageOption = [10, 25, 50, 100];
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(100);
  const [pageCount, setPageCount] = useState(0);
  const [data, setData] = useState([]);
  const [supplier, setSupplier] = useState([]);
  const [vendor, setVendor] = useState([]);
  const [catData, setCatData] = useState([]);
  const [subData, setSubData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [csvLoading, setCsvLoading] = useState(false);

  const [dateLimit, setDateLimit] = useState({
    fromDate: moment().subtract(1, "months").format(),
    toDate: moment().format(),
  });

  const [totalAmount, setTotalAmount] = useState(0);
  const [totalFlag, setTotalFlag] = useState(false);

  // New state variables to store other global totals returned from backend metrics if needed
  const [globalSummary, setGlobalSummary] = useState(null);

  const [options, setOptions] = useState({
    customer: null,
    category: null,
    subCategory: null,
    vendor: null,
  });

  const [reportType, setReportType] = useState("category");

  const toNum = (v) => (isNaN(Number(v)) ? 0 : Number(v));

  function handleOptions(value, name) {
    setPage(0);
    setOptions((prev) => ({ ...prev, [name]: value }));
  }

  const columns = [
    {
      field: "sno",
      headerName: "S.no",
      minWidth: 70,
      maxWidth: 100,
      headerAlign: "center",
      align: "center",
      sortable: false,
    },
    ...(reportType === "item"
      ? [{
          field: "item_name",
          headerName: "Item Name",
          flex: 1,
          minWidth: 160,
          headerAlign: "center",
          align: "center",
          sortable: false,
        }]
      : []),
    {
      field: "outlet_name",
      headerName: "Outlet Name",
      flex: 1,
      minWidth: 140,
      headerAlign: "center",
      align: "center",
      sortable: false,
    },
    {
      field: "supplier_name",
      headerName: "Supplier Name",
      flex: 1,
      minWidth: 140,
      headerAlign: "center",
      align: "center",
      sortable: false,
    },
    {
      field: "category_name",
      headerName: "Category Name",
      flex: 1,
      minWidth: 140,
      headerAlign: "center",
      align: "center",
      sortable: false,
    },
    {
      field: "subcategory_name",
      headerName: "Subcategory Name",
      flex: 1,
      minWidth: 150,
      headerAlign: "center",
      align: "right",
      sortable: false,
    },
    {
      field: "total_qty",
      headerName: "Qty",
      flex: 1,
      minWidth: 100,
      headerAlign: "center",
      align: "right",
      sortable: false,
    },
    {
      field: "total_mrp",
      headerName: "MRP Value",
      flex: 1,
      minWidth: 120,
      headerAlign: "center",
      align: "right",
      sortable: false,
    },
    {
      field: "total_discount_amount",
      headerName: "Discount Amount",
      flex: 1,
      minWidth: 140,
      headerAlign: "center",
      align: "right",
      sortable: false,
    },
    {
      field: "discounted_mrp",
      headerName: "MRP - Discount",
      flex: 1,
      minWidth: 140,
      headerAlign: "center",
      align: "right",
      sortable: false,
    },
    {
      field: "purchase_value_percent",
      headerName: "Purchase Value %",
      flex: 1,
      minWidth: 150,
      headerAlign: "center",
      align: "right",
      sortable: false,
    },
    {
      field: "gross_profit_percent",
      headerName: "Gross Profit %",
      flex: 1,
      minWidth: 130,
      headerAlign: "center",
      align: "right",
      sortable: false,
      renderCell: (params) => <strong>{params.value}</strong>,
    },
    {
      field: "discounted_gross_profit_percent",
      headerName: "Discounted GP %",
      flex: 1,
      minWidth: 160,
      headerAlign: "center",
      align: "right",
      sortable: false,
    },
  ];

  const rows = _.map(data, (val, idx) => ({
    id: idx + 1,
    sno: page * rowsPerPage + idx + 1,
    item_name:                    val.item_name        || "",
    outlet_name:                  val.outlet_name      || "",
    supplier_name:                val.supplier_name    || "",
    category_name:                val.category_name    || "",
    subcategory_name:             val.subcategory_name || "",
    total_qty:                    toNum(val.total_qty).toFixed(2),
    total_mrp:                    toNum(val.total_mrp).toFixed(2),
    total_discount_amount:       toNum(val.total_discount_amount).toFixed(2),
    discounted_mrp:               toNum(val.discounted_mrp).toFixed(2),
    purchase_value_percent:          toNum(val.purchase_value_percent).toFixed(2),
    gross_profit_percent:            toNum(val.gross_profit_percent).toFixed(2),
    discounted_gross_profit_percent: toNum(val.discounted_gross_profit_percent).toFixed(2),
  }));

  const props = {
    columns,
    rows,
    page,
    setPage,
    rowsPerPage,
    setRowsPerPage,
    pageCount,
    pageOption,
    totalAmount,
    totalFlag,
    setSearch: () => {},
  };

  // ✅ Client side array reduction removed. 
  // This side effect handles layout flag synchronization.
  useEffect(() => {
    setTotalFlag(true);
  }, [data]);

  function handleChange(e, name) {
    setDateLimit((prev) => ({ ...prev, [name]: dayjs(e).format() }));
  }

  function getSupplierData() {
    axios.get("/v1/outlet/list/1")
      .then((res) => setSupplier([{ id: 0, fullname: "All" }, ...res.data]))
      .catch((err) => dispatch(setSnackbar(true, "error", err.response?.data?.error)));
  }

  function getVendorData() {
    axios.get("/v1/supplier")
      .then((res) => setVendor(res.data))
      .catch((err) => dispatch(setSnackbar(true, "error", err.response?.data?.error)));
  }

  function getCategory() {
    axios.get("/v1/categories")
      .then((res) => setCatData(res.data.filter((val) => val.is_active)))
      .catch((err) => dispatch(setSnackbar(true, "error", err.response?.data?.error)));
  }

  function getSubCategory() {
    axios.get("/v1/subcategories")
      .then((res) => setSubData(res.data))
      .catch((err) => dispatch(setSnackbar(true, "error", err.response?.data?.error)));
  }
  
  function handleSalesReturn() {
    if (!options.customer) return;

    setLoading(true);

    const postData = {
      from_date:   moment(dateLimit.fromDate).format("YYYY-MM-DD"),
      to_date:     moment(dateLimit.toDate).format("YYYY-MM-DD"),
      vendor_id:   options.vendor?.id      || 0,
      outlet_id:   options.customer?.id    ?? 0,
      main_cat_id: options.category?.id    || 0,
      sub_cat_id:  options.subCategory?.id || 0,
    };

    const url = reportType === "item"
      ? `/v1/reports/sales/profit/itemwise/${rowsPerPage}/${page + 1}`
      : `/v1/reports/sales/profit/${rowsPerPage}/${page + 1}`;

    axios.post(url, postData)
      .then((res) => {
        setData(res.data?.data || []);
        setPageCount(res.data?.meta?.pagination?.total || 0);
        
        // ✅ Read accurate backend overall calculation directly from metadata summary
        const overallGP = res.data?.meta?.summary?.overall_gross_profit_percent;
        setTotalAmount(toNum(overallGP).toFixed(2));
        setGlobalSummary(res.data?.meta?.summary || null);
      })
      .catch((err) => {
        setData([]);
        setPageCount(0);
        setTotalAmount(0);
        setGlobalSummary(null);
        dispatch(setSnackbar(
          true, "error",
          err.response?.data?.errors?.[0]?.message || "Something went wrong"
        ));
      })
      .finally(() => setLoading(false));
  }

  function handleReset() {
    setOptions({ customer: null, category: null, subCategory: null, vendor: null });
    setDateLimit({
      fromDate: moment().subtract(1, "months").format(),
      toDate: moment().format(),
    });
    setReportType("category");
    setPage(0);
    setData([]);
    setPageCount(0);
    setTotalAmount(0);
    setGlobalSummary(null);
  }

  const handleDownloadCSV = async () => {
    if (!options.customer) {
      dispatch(setSnackbar(true, "error", "Please select an outlet"));
      return;
    }
    if (csvLoading) return;
    setCsvLoading(true);

    const postData = {
      from_date:   moment(dateLimit.fromDate).format("YYYY-MM-DD"),
      to_date:     moment(dateLimit.toDate).format("YYYY-MM-DD"),
      vendor_id:   options.vendor?.id      || 0,
      outlet_id:   options.customer?.id    ?? 0,
      main_cat_id: options.category?.id    || 0,
      sub_cat_id:  options.subCategory?.id || 0,
    };

    const url = reportType === "item"
      ? `/v1/reports/sales/profit/itemwise/99999/1`
      : `/v1/reports/sales/profit/99999/1`;

    try {
      const res     = await axios.post(url, postData);
      const allRows = res.data?.data || [];
      const isItem  = reportType === "item";

      // ✅ Get exact overall gross profit from global metadata for CSV too
      const csvOverallGP = res.data?.meta?.summary?.overall_gross_profit_percent ?? 0;

      const headers = isItem
        ? ["S.no", "Item Name", "Outlet", "Supplier", "Category", "Subcategory", "Qty", "MRP Value", "Discount Amount", "MRP - Discount", "Purchase Value %", "Gross Profit %", "Discounted GP %"]
        : ["S.no", "Outlet", "Supplier", "Category", "Subcategory", "Qty", "MRP Value", "Discount Amount", "MRP - Discount", "Purchase Value %", "Gross Profit %", "Discounted GP %"];

      const dataRows = allRows.map((val, idx) =>
        isItem
          ? [
              idx + 1,
              val.item_name              || "",
              val.outlet_name            || "",
              val.supplier_name          || "",
              val.category_name          || "",
              val.subcategory_name       || "",
              toNum(val.total_qty).toFixed(2),
              toNum(val.total_mrp).toFixed(2),
              toNum(val.total_discount_amount).toFixed(2),
              toNum(val.discounted_mrp).toFixed(2),
              toNum(val.purchase_value_percent).toFixed(2),
              toNum(val.gross_profit_percent).toFixed(2),
              toNum(val.discounted_gross_profit_percent).toFixed(2),
            ]
          : [
              idx + 1,
              val.outlet_name            || "",
              val.supplier_name          || "",
              val.category_name          || "",
              val.subcategory_name       || "",
              toNum(val.total_qty).toFixed(2),
              toNum(val.total_mrp).toFixed(2),
              toNum(val.total_discount_amount).toFixed(2),
              toNum(val.discounted_mrp).toFixed(2),
              toNum(val.purchase_value_percent).toFixed(2),
              toNum(val.gross_profit_percent).toFixed(2),
              toNum(val.discounted_gross_profit_percent).toFixed(2),
            ]
      );

      const footerRow = isItem
        ? ["", "", "", "", "", "", "", "", "", "", "", "", `Overall Gross Profit %: ${toNum(csvOverallGP).toFixed(2)}`]
        : ["", "", "", "", "", "", "", "", "", "", "", `Overall Gross Profit %: ${toNum(csvOverallGP).toFixed(2)}`];

      const csvData = [
        ["Outlet Name", options.customer?.fullname || ""],
        ["From Date",   moment(dateLimit.fromDate).format("DD-MM-YYYY")],
        ["To Date",     moment(dateLimit.toDate).format("DD-MM-YYYY")],
        ["Report Type", isItem ? "Item Wise" : "Category Wise"],
        [],
        headers,
        ...dataRows,
        [],
        footerRow,
      ];

      const csvContent = csvData
        .map((row) => row.map((item) => `"${item ?? ""}"`).join(","))
        .join("\n");

      const blob = new Blob([csvContent], { type: "text/csv" });
      const url2 = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url2;
      link.setAttribute("download",
        `${isItem ? "ItemWise" : "CategoryWise"}_Profit_Report_${moment().format("YYYY-MM-DD")}.csv`
      );
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      dispatch(setSnackbar(
        true, "error",
        error?.response?.data?.errors?.[0]?.message || "CSV Download failed"
      ));
    } finally {
      setCsvLoading(false);
    }
  };

  useEffect(() => {
    getSupplierData();
    getCategory();
    getSubCategory();
    getVendorData();
  }, []);

  useEffect(() => {
    if (options.customer && dateLimit.fromDate && dateLimit.toDate) {
      handleSalesReturn();
    }
  }, [rowsPerPage, page, dateLimit, options, reportType]);

  return (
    <Fragment>
      <Helmet><title>Net Profit Sales Reports</title></Helmet>
      <Typography variant="h6">Net Profit Sales Reports</Typography>

      <Grid container spacing={2} className="p-2 pt-2">

        <Grid item md={3}>
          <Autocomplete
            size="small"
            options={supplier}
            value={options.customer || null}
            onChange={(e, value) => handleOptions(value, "customer")}
            getOptionLabel={(option) => option.fullname}
            isOptionEqualToValue={(option, value) => option?.id === value?.id}
            clearOnEscape
            renderInput={(params) => <TextField {...params} label="Select Outlet *" />}
          />
        </Grid>

        <Grid item md={3}>
          <Autocomplete
            size="small"
            value={options.vendor}
            options={vendor}
            getOptionLabel={(option) => option?.name || ""}
            isOptionEqualToValue={(o, v) => o?.id === v?.id}
            onChange={(e, value) => handleOptions(value, "vendor")}
            renderInput={(params) => <TextField {...params} label="Supplier" />}
          />
        </Grid>

        <Grid item md={3}>
          <Autocomplete
            size="small"
            value={options.category}
            options={catData}
            getOptionLabel={(option) => option.category_name}
            onChange={(e, value) => handleOptions(value, "category")}
            renderInput={(params) => <TextField {...params} label="Category" />}
          />
        </Grid>

        <Grid item md={3}>
          <Autocomplete
            size="small"
            options={subData}
            value={options.subCategory}
            getOptionLabel={(option) => option.subcategory_name}
            onChange={(e, value) => handleOptions(value, "subCategory")}
            renderInput={(params) => <TextField {...params} label="Sub Category" />}
          />
        </Grid>

        <Grid item md={3}>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              onChange={(e) => handleChange(e, "fromDate")}
              value={dayjs(dateLimit.fromDate)}
              format="DD-MM-YYYY"
              slotProps={{ textField: { size: "small", label: "From", style: { width: "100%" } } }}
            />
          </LocalizationProvider>
        </Grid>

        <Grid item md={3}>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              onChange={(e) => handleChange(e, "toDate")}
              value={dayjs(dateLimit.toDate)}
              format="DD-MM-YYYY"
              slotProps={{ textField: { size: "small", label: "To", style: { width: "100%" } } }}
            />
          </LocalizationProvider>
        </Grid>

        <Grid item md={3}>
          <RadioGroup
            row
            value={reportType}
            onChange={(e) => { setPage(0); setReportType(e.target.value); }}
          >
            <FormControlLabel value="category" control={<Radio />} label="CategoryWise" />
            <FormControlLabel value="item"     control={<Radio />} label="ItemWise" />
          </RadioGroup>
        </Grid>

        <Grid item md={1.5}>
          <Button variant="contained" color="secondary" fullWidth onClick={handleReset}>
            Reset
          </Button>
        </Grid>

        <Grid item md={1.5}>
          <Button
            variant="contained"
            fullWidth
            onClick={handleDownloadCSV}
            disabled={csvLoading}
          >
            {csvLoading ? <CircularProgress size={22} color="inherit" /> : "Download"}
          </Button>
        </Grid>
      </Grid>

      <Box position="relative" width="100%">
        <Paper elevation={2}>
          <CustomTable props={props} />
        </Paper>
        {loading && (
          <Box
            display="flex" justifyContent="center" alignItems="center"
            position="absolute" top={0} left={0} right={0} bottom={0}
            bgcolor="rgba(255, 255, 255, 0.7)" zIndex={1}
          >
            <CircularProgress size={50} />
          </Box>
        )}
      </Box>
    </Fragment>
  );
};

export default memo(NetProfitSalesReport);